import { SkeletonFrame, SkeletonType } from '@nextgen-web-framework/all';
import styles from './TextCardLoader.module.scss';

const TextCardLoader = () => {
  const skeletonLoader = (
    <SkeletonFrame className={styles.skeleton} type={SkeletonType.FULL_WIDTH} isRoundCorner heightValue="24" />
  );

  return (
    <div className={styles['text-card-loader']}>
      {skeletonLoader}
      {skeletonLoader}
      {skeletonLoader}
    </div>
  );
};

export default TextCardLoader;
